import React, { useEffect, useRef, useState } from 'react'
import http from '../../core/http-common'

const AsyncImage = (props: any) => {
  const [loadedSrc, setLoadedSrc] = useState<string | null>(null)
  const [hasError, setHasError] = useState(false)
  const cancelledRef = useRef(false)
  
  useEffect(() => {
    setLoadedSrc(null)
    setHasError(false)
    cancelledRef.current = false
    
    if (props.src) {
      // Employee photo API paths need to be fetched via axios (requires auth headers)
      if (props.src.includes('/Employee/GetEmployeePhoto')) {
        const base64Url = props.src.replace('GetEmployeePhoto?', 'GetEmployeePhotoBase64String?')
        http.get<string>(base64Url)
          .then((response) => {
            if (!cancelledRef.current && response.data) {
              setLoadedSrc(`data:image/png;base64,${response.data}`)
            }
          })
          .catch(() => {
            if (!cancelledRef.current) setHasError(true)
          })
      } else {
        const handleLoad = () => {
          if (!cancelledRef.current) {
            setLoadedSrc(props.src)
            setHasError(false)
          }
        }
        const handleError = () => {
          if (!cancelledRef.current) {
            setHasError(true)
            setLoadedSrc(null)
          }
        }
        
        const image = new Image()
        image.addEventListener('load', handleLoad)
        image.addEventListener('error', handleError)
        image.src = props.src
        
        return () => {
          cancelledRef.current = true
          image.removeEventListener('load', handleLoad)
          image.removeEventListener('error', handleError)
        }
      }
    }

    return () => { cancelledRef.current = true }
  }, [props.src])
  
  if (hasError && props.fallback) {
    return props.fallback
  }
  
  if (loadedSrc) {
    const { fallback, ...imgProps } = props
    return <img {...imgProps} src={loadedSrc} />
  }
  
  return null
}

export default AsyncImage
